export const backgroundDefault = [
  { directive: 'background-repeat', value: 'repeat' },
  { directive: 'background-size', value: 'auto' },
  { directive: 'background-position-x', value: '50%' },
  { directive: 'background-position-y', value: '50%' },
]
